import React from 'react';
import { useSelector } from 'umi';

import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { CASUAL_PAGE_CONFIG } from './casualPageConfig';
const reqParams = '/realtime/iaaRevenue';
const RealtimeIaaRevenue = () => {
  const dataFrame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile';
  });
  const pageMap: any = {
    casual: CASUAL_PAGE_CONFIG
  };
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame]} />
    </>
  );
};

export default RealtimeIaaRevenue;
